<bic-popup (close)="close()" [hasBackdrop]="true"
           customClass="w-[960px] max-w-[92vw] max-h-[92vh] overflow-y-auto overflow-x-hidden"
           title="Prüfregel testen">
  <div bicPopupContent class="flex flex-col items-stretch gap-5">

    <!-- Hinweis (Figma: Inline Hint) -->
    <div class="flex items-center gap-2">
      <fa-icon [icon]="faCircleInfo" class="text-svg-16 text-gray-500 shrink-0"></fa-icon>
      <p class="flex-1 min-w-0 text-sm font-medium text-gray-500">
        Getestet wird der aktuelle, noch nicht übernommene Stand dieses Prüfregelsets. Das Ergebnis wird nicht
        gespeichert und verbraucht keine Credits.
      </p>
    </div>

    <!-- Auswahl -->
    @if (poolMode) {
      <div class="flex flex-col gap-4">
        <div class="flex flex-col gap-1 min-w-0">
          <bic-select (valueChange)="onRuleChange($event)" [disabled]="ruleSelectDisabled" [value]="selectedRuleKey"
                      dropdownStrategy="fixed" [label]="ruleFieldLabel" [placeholder]="rulePlaceholder">
            <fa-icon #iconStart [icon]="faCube" class="text-svg-16 text-gray-500" iconStart></fa-icon>
            @for (option of ruleOptions; track option.key) {
              <bic-dropdown-element [value]="option.key">{{ option.label }}</bic-dropdown-element>
            }
          </bic-select>
          <p class="text-xs text-gray-500">{{ ruleHint }}</p>
        </div>

        <div class="flex flex-col gap-2">
          <span class="text-sm font-medium text-gray-900">Dateien je Dokumententyp *</span>
          @for (row of poolRows; track row.key) {
            <div class="flex items-start gap-4">
              <span class="w-40 shrink-0 pt-2 text-sm text-gray-900 truncate">{{ row.name }}</span>
              <div class="flex flex-col gap-1 flex-1 min-w-0">
                <bic-select (valueChange)="onPoolFileChange(row.key, $event)"
                            [disabled]="fileSelectDisabled || filesLoading || row.options.length === 0"
                            [placeholder]="filesLoading ? 'Dateien werden geladen …' : (row.options.length === 0 ? 'Keine passende Datei im Projekt' : 'Datei auswählen …')"
                            [value]="row.selectedFileId"
                            dropdownStrategy="fixed">
                  <fa-icon #iconStart [icon]="faFile" class="text-svg-16 text-gray-500" iconStart></fa-icon>
                  @if (row.options.length >= fileSearchMinOptions) {
                    <!-- Suche in der Liste: sitzt im Dropdown, bleibt beim Scrollen oben und fluchtet mit den
                         Einträgen (px-4) – ohne eigenen Rahmen, nur eine Trennlinie. Klicks und
                         Tasten bleiben hier, damit sie das Dropdown weder schließen noch steuern. -->
                    <div (click)="$event.stopPropagation()"
                         class="sticky top-0 z-10 flex items-center gap-2 border-b border-gray-200 bg-white px-4">
                      <fa-icon [icon]="faMagnifyingGlass" class="text-svg-16 text-gray-400"></fa-icon>
                      <input (input)="onPoolSearch(row.key, $any($event.target).value)" (keydown)="$event.stopPropagation()" [value]="row.search"
                             aria-label="Datei suchen" autocomplete="off"
                             class="w-full border-0 bg-transparent px-0 py-2.5 text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-0"
                             placeholder="Datei suchen …" type="text">
                    </div>
                  }
                  @for (option of row.visibleOptions; track option.id) {
                    <bic-dropdown-element [value]="option.id">{{ option.name }}</bic-dropdown-element>
                  }
                  @if (row.searchEmpty) {
                    <p class="px-4 py-2 text-sm text-gray-500">Keine Datei gefunden</p>
                  }
                </bic-select>
                <p class="text-xs text-gray-500">
                  {{ row.hint }}
                  @if (!filesLoading && row.options.length === 0) {
                    · <a (click)="onUploadLinkClick()" [href]="uploadHref" class="text-green hover:underline"
                         rel="noopener" target="_blank">Datei hochladen ↗</a>
                  }
                </p>
              </div>
            </div>
          }
        </div>
      </div>
    } @else {
      <div class="flex items-start gap-4">
        <div class="flex flex-col gap-1 flex-1 min-w-0">
          <bic-select (valueChange)="onFileChange($event)"
                      [disabled]="fileSelectDisabled || filesLoading || noFiles"
                      [placeholder]="filesLoading ? 'Dateien werden geladen …' : (noFiles ? 'Keine passende Datei im Projekt' : 'Datei auswählen …')"
                      [value]="selectedFileId"
                      dropdownStrategy="fixed" label="Datei *">
            <fa-icon #iconStart [icon]="selectedFileIcon" class="text-svg-16 text-gray-500" iconStart></fa-icon>
            @if (showFileSearch) {
              <!-- Suche in der Liste: sitzt im Dropdown, bleibt beim Scrollen oben und fluchtet mit den
                   Einträgen (px-4) – ohne eigenen Rahmen, nur eine Trennlinie. Klicks und
                   Tasten bleiben hier, damit sie das Dropdown weder schließen noch steuern. -->
              <div (click)="$event.stopPropagation()"
                   class="sticky top-0 z-10 flex items-center gap-2 border-b border-gray-200 bg-white px-4">
                <fa-icon [icon]="faMagnifyingGlass" class="text-svg-16 text-gray-400"></fa-icon>
                <input (input)="onFileSearch($any($event.target).value)" (keydown)="$event.stopPropagation()" [value]="fileSearch"
                       aria-label="Datei suchen" autocomplete="off"
                       class="w-full border-0 bg-transparent px-0 py-2.5 text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-0"
                       placeholder="Datei suchen …" type="text">
              </div>
            }
            @for (option of visibleFileOptions; track option.id) {
              <bic-dropdown-element [value]="option.id">{{ option.name }}</bic-dropdown-element>
            }
            @if (fileSearchEmpty) {
              <p class="px-4 py-2 text-sm text-gray-500">Keine Datei gefunden</p>
            }
          </bic-select>
          <p class="text-xs text-gray-500">
            {{ fileHint }}
            @if (noFiles) {
              · <a (click)="onUploadLinkClick()" [href]="uploadHref" class="text-green hover:underline"
                   rel="noopener" target="_blank">Datei hochladen ↗</a>
            }
          </p>
        </div>
        <div class="flex flex-col gap-1 flex-1 min-w-0">
          <bic-select (valueChange)="onRuleChange($event)" [disabled]="ruleSelectDisabled" [value]="selectedRuleKey"
                      dropdownStrategy="fixed" [label]="ruleFieldLabel" [placeholder]="rulePlaceholder">
            <fa-icon #iconStart [icon]="faCube" class="text-svg-16 text-gray-500" iconStart></fa-icon>
            @for (option of ruleOptions; track option.key) {
              <bic-dropdown-element [value]="option.key">{{ option.label }}</bic-dropdown-element>
            }
          </bic-select>
          <p class="text-xs text-gray-500">{{ ruleHint }}</p>
        </div>
      </div>
    }

    <!-- Editor-Stand ungültig (Plan §3.3) -->
    @if (blockingErrors.length && view !== 'running') {
      <div class="flex gap-3 rounded-lg border border-yellow-300 bg-yellow-50 p-4" role="alert">
        <fa-icon [icon]="faTriangleExclamation" class="text-svg-16 text-yellow-600 shrink-0 pt-0.5"></fa-icon>
        <div class="flex flex-col gap-1 min-w-0">
          <p class="text-sm font-medium text-gray-900">Testlauf nicht möglich</p>
          <ul class="list-disc ps-4 text-sm text-gray-700">
            @for (error of blockingErrors; track error) {
              <li>{{ error }}</li>
            }
          </ul>
        </div>
      </div>
    }

    <!-- 409: es läuft schon ein Testlauf -->
    @if (activeRunId) {
      <div class="flex items-center justify-between gap-4 rounded-lg border border-gray-200 bg-gray-50 p-4" role="status">
        <p class="text-sm text-gray-700">Es läuft bereits ein Testlauf. Warte, bis er fertig ist, oder verfolge ihn hier.</p>
        <bic-button (onClick)="openActiveRun()" buttonType="white">Laufenden Testlauf öffnen</bic-button>
      </div>
    }

    <!-- Ergebnis-Preview -->
    <div class="flex flex-col gap-2">
      <div class="flex items-center justify-between whitespace-nowrap">
        <span class="text-sm font-medium text-gray-900">Ergebnis-Preview</span>
        <span class="text-xs text-gray-500">Ergebnis wird nicht gespeichert</span>
      </div>

      @switch (view) {
        @case ('running') {
          <!-- Frame 03: Loading Check -->
          <div class="flex min-h-80 flex-col items-center justify-center gap-2 rounded-lg border border-dashed border-gray-200 bg-gray-50 px-8"
               aria-live="polite">
            <div class="flex w-full flex-col justify-center gap-1 rounded-lg p-4">
              <div class="flex w-full items-center gap-2">
                <p class="flex-1 min-w-0 text-base font-medium text-gray-900">Testlauf läuft …</p>
                <div class="flex items-center gap-4 text-xs whitespace-nowrap">
                  @if (progressStepText) {
                    <span class="text-gray-900">{{ progressStepText }}</span>
                  }
                  <span class="text-gray-500">Dauer: {{ elapsedLabel }}</span>
                  <span class="font-medium text-green">{{ progressPercent }} %</span>
                </div>
              </div>
              <div [attr.aria-valuenow]="progressPercent" aria-valuemax="100" aria-valuemin="0"
                   class="relative h-1.5 w-full overflow-hidden rounded-xl bg-gray-200" role="progressbar">
                <div [style.width.%]="progressPercent" class="absolute inset-y-0 left-0 rounded-xl bg-green transition-all"></div>
              </div>
              <p class="text-center text-xs text-gray-500 truncate">{{ runSummary }}</p>
            </div>
            <p class="text-center text-xs text-gray-500">
              Du kannst das Popup schließen – der Testlauf läuft weiter, das Ergebnis erscheint dann als Hinweis.
            </p>
          </div>
        }
        @case ('result') {
          <!-- Frame 04 -->
          <app-rule-test-result-preview [reportConfig]="context?.reportConfig ?? null" [idsThresholds]="context?.idsThresholds ?? null" [run]="run"/>
        }
        @case ('error') {
          <!-- Frame 07 -->
          <div class="flex min-h-80 flex-col items-center justify-center gap-2 rounded-lg border border-dashed border-red bg-red-50 px-8"
               role="alert">
            <div class="flex h-12 w-12 items-center justify-center rounded-full bg-white">
              <fa-icon [icon]="faXmark" class="text-svg-22 text-red"></fa-icon>
            </div>
            <p class="text-sm font-medium text-gray-900">Testlauf fehlgeschlagen</p>
            <div class="text-center text-xs text-gray-500">
              <p>{{ errorMessage }}</p>
              <p>Der Testlauf wird nicht auf dein Tageslimit angerechnet.</p>
            </div>
          </div>
        }
        @default {
          <!-- Frame 02 -->
          <div class="flex min-h-80 flex-col items-center justify-center gap-2 rounded-lg border border-dashed border-gray-200 bg-gray-50 px-8">
            <fa-icon [icon]="faPlay" class="text-svg-22 text-gray-500"></fa-icon>
            <p class="text-sm font-medium text-gray-900">Noch kein Testergebnis</p>
            <div class="text-center text-xs text-gray-500">
              <p>Wähle eine Datei und eine {{ ruleNoun }} und starte den Testlauf.</p>
              <p>Das Ergebnis erscheint hier im gleichen Format wie im Bericht.</p>
            </div>
          </div>
        }
      }
    </div>
  </div>

  <div bicPopupButtonGroup class="flex flex-1 items-center justify-between gap-4">
    @if (quota) {
      <app-quota-segments [limit]="quota.limit" [resetsAt]="quota.resetsAt" [used]="quota.used"/>
    } @else {
      <span></span>
    }
    <div class="flex items-start gap-4">
      <bic-button (onClick)="close()" buttonType="white">{{ secondaryLabel }}</bic-button>
      <span [tooltipSubtext]="startTooltipSubtext" [tooltip]="startTooltip" tooltipDirection="top">
        <bic-button (onClick)="start()" [disabled]="!canStart" [loading]="starting" buttonType="primary">
          <fa-icon [icon]="primaryIcon" class="text-svg-16" iconLeft></fa-icon>
          {{ primaryLabel }}
        </bic-button>
      </span>
    </div>
  </div>
</bic-popup>
